var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 14,
    viewBox: "0 0 92 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CALEIDO"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M78.4062 7.46654C78.4062 5.10988 79.6663 2.98654 81.6729 1.81988C82.6763 1.23654 83.7496 0.956543 84.9396 0.956543C87.2963 0.956543 89.4196 2.21654 90.5863 4.19988C91.1696 5.20321 91.4496 6.27654 91.4496 7.46654C91.4496 9.82321 90.1896 11.9465 88.2063 13.1132C87.2029 13.6965 86.1296 13.9999 84.9396 13.9999C82.5829 13.9999 80.4596 12.7399 79.2929 10.7332C78.7096 9.72988 78.4062 8.65654 78.4062 7.46654ZM80.8329 7.46654C80.8329 9.72988 82.6763 11.5732 84.9396 11.5732C87.1796 11.5732 89.0229 9.72988 89.0229 7.46654C89.0229 5.99654 88.2529 4.66654 86.9929 3.91988C86.3629 3.56988 85.6629 3.38321 84.9396 3.38321C82.6763 3.38321 80.8329 5.22654 80.8329 7.46654Z",
    fill: "#D7C0FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M63.9609 13.9999V0.956543H68.2543C70.6109 0.956543 72.7109 2.21654 73.9009 4.19988C74.4843 5.20321 74.7876 6.27654 74.7876 7.46654C74.7876 9.82321 73.5043 11.9465 71.5209 13.1132C70.5176 13.6965 69.4443 13.9999 68.2543 13.9999H63.9609ZM66.3876 11.5732H68.2543C70.5176 11.5732 72.3609 9.72988 72.3609 7.46654C72.3609 5.22654 70.5176 3.38321 68.2543 3.38321H66.3876V11.5732Z",
    fill: "#D7C0FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M56.6406 13.9999V0.956543H59.0673V13.9999H56.6406Z",
    fill: "#D7C0FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M42.959 0.956543H52.4323V3.38321H45.3857V6.25321H48.909V8.67988H45.3857V11.5732H52.4323V13.9999H42.959V0.956543Z",
    fill: "#D7C0FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M30.3066 13.9999V0.956543H32.7333V11.5732H38.9866V13.9999H30.3066Z",
    fill: "#D7C0FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.0198 13.9999H14.4531L18.8165 0.956543H22.0831L26.4465 13.9999H23.8798L22.7598 10.6399H18.1398L17.0198 13.9999ZM20.4498 3.73321L18.9565 8.21321H21.9431L20.4498 3.73321Z",
    fill: "#D7C0FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M0.886667 10.7332C0.303334 9.72988 0 8.65654 0 7.46654C0 5.10988 1.26 2.98654 3.24333 1.81988C4.24667 1.23654 5.32 0.956543 6.51 0.956543C8.56333 0.956543 10.5233 1.91321 11.7367 3.56988L9.8 5.03988C8.98333 3.98988 7.81667 3.38321 6.51 3.38321C4.27 3.38321 2.42667 5.22654 2.42667 7.46654C2.42667 9.72988 4.27 11.5732 6.51 11.5732C7.81667 11.5732 8.98333 10.9665 9.8 9.93988L11.7367 11.3865C10.5 13.0432 8.56333 13.9999 6.51 13.9999C4.15333 13.9999 2.03 12.7632 0.886667 10.7332Z",
    fill: "#D7C0FB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3e18a7444a820ba01533530fe18099e0.svg";
export { ForwardRef as ReactComponent };